
import {onClick, onChange} from '../abstract/helpers.js';


export class ReplacePageContent {
  constructor() {

    this.paged = 1;
    this.controller = new AbortController();
    this.signal = this.controller.signal;
    this.hasOngoingFetch = false;

    if(document.querySelector('.default-content-area .card-wrapper .card-roll')) {
      if(document.querySelector('.default-content-area .card-wrapper .card-roll').innerHTML.trim() === "") {
        document.querySelector('.default-content-area .card-wrapper .card-roll').innerHTML = this.getNoPostsMessage();
      }
    }

    document.querySelectorAll('#filter-form #sort').forEach((element) => {
      element.onchange = function() {
        this.sendPageRequest(true);
      }.bind(this)
    });

    this.setupPaginationClick();

  }

  getNoPostsMessage() {
    return "<h2>No Posts Found</h2>";
  }

  setupPaginationClick() {

    onClick(document.querySelector('.menu-style-1 input[type=checkbox]'), function (e) {
      this.sendPageRequest(true);
    }.bind(this));

    onClick(document.querySelector('.pagination-load-more a'), function (e) {
      e.preventDefault();
      this.sendPageRequest(false);
    }.bind(this));

    onClick(document.querySelector('#filter-form button'), function (e) {
      e.preventDefault();
      this.sendPageRequest(true);
    }.bind(this));
  }

  sendPageRequest(reset) {

    let isReplace = true;
    if(this.hasOngoingFetch) {
      //this.controller.abort();
      this.hasOngoingFetch = false;
      //this.sendPageRequest(reset);
    } else {
      this.hasOngoingFetch = true;
    }


    if(reset) {
      this.paged = 1;
    } else {
      isReplace = false;
      this.paged = this.paged + 1;
    }
  
    let url = window.location.href.split('?')[0]+"?paged="+this.paged;    

    let search = document.querySelector('#search');
    let surname = document.querySelector('#surname');
    let author = document.querySelector('#author');
    let sort = document.querySelector('#sort');
    let rank = document.querySelector('#rank');
    let site = document.querySelector('#site');
    let field_of_study = document.querySelector('#field_of_study');
    let past_projects = document.querySelector('#past_projects');
    let funding_source = document.querySelector('#funding_source');

    
    if(search && search.value != "") {
      url +="&search-element="+search.value;
    }
    if(surname && surname.value != "") {
      url +="&surname-element="+surname.value;
    }
    
    if(author && author.value != "") {
      url +="&author-element="+author.value;
    }

    if(sort && sort.value != "") {
      url +="&sort-element="+sort.value;
    }

    if(rank && rank.value != "") {
      url +="&rank-element="+rank.value;
    }

    if(site && site.value != "") {
      url +="&site-element="+site.value;
    }

    if(field_of_study && field_of_study.value != "") {
      url +="&field_of_study-element="+field_of_study.value;
    }

    if(past_projects && past_projects.value != "") {
      url +="&past_projects-element="+past_projects.checked;
    }

    if(funding_source && funding_source.value != "") {
      url +="&funding_source-element="+funding_source.value;
    }
        
    history.pushState({}, document.querySelector('title').innerHTML, url);

    document.querySelector('.default-content-area .card-wrapper').classList.add("loading");

    let initial_count = 0;
    if(document.querySelector('.default-content-area .card-wrapper .card-roll').children.length) {
      initial_count = document.querySelector('.default-content-area .card-wrapper .card-roll').children.length;
    }
    
    fetch(url, {method: 'GET',signal: this.signal,})
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      this.hasOngoingFetch = false;
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      let element = doc.querySelector('.default-content-area .card-wrapper .card-roll');
      let pagination = doc.querySelector('.default-content-area .card-wrapper .pagination-numbers');

      if(typeof(element) != 'undefined' && element != null) {
        if(reset) {
  
          document.querySelector('.default-content-area .card-wrapper .card-roll').innerHTML = element.innerHTML;

        } else {
  
          document.querySelector('.default-content-area .card-wrapper .card-roll').insertAdjacentHTML('beforeend', element.innerHTML);

        }

        if(element.children.length < initial_count) {
          if(document.querySelector('.pagination-load-more a')) {
            document.querySelector('.pagination-load-more a').classList.add("hidden");
          }
        }
        
      } else {
        if(document.querySelector('.pagination-load-more a')) {
          document.querySelector('.pagination-load-more a').classList.add("hidden");
        }
      }

      
      if(reset && (element.innerHTML.trim() === "" || typeof(element) === 'undefined' || element === null)) {
        document.querySelector('.default-content-area .card-wrapper .card-roll').innerHTML = this.getNoPostsMessage();
      }

      if(typeof(pagination) != 'undefined' && pagination != null && document.querySelector('.default-content-area .card-wrapper .pagination-numbers')) {
        document.querySelector('.default-content-area .card-wrapper .pagination-numbers').innerHTML = pagination.innerHTML;
      } else {
        document.querySelector('.default-content-area .card-wrapper .pagination-numbers').innerHTML = '';
      }

      document.querySelector('.default-content-area .card-wrapper').classList.remove("loading");

    }.bind(this).bind(initial_count)).catch(function (err) {
      // There was an error
      document.querySelector('.default-content-area .card-wrapper').classList.remove("loading");
      console.warn('Something went wrong.', err);
    });

  }
}


